class PeopleSearch {
    constructor($scope, $state, $rootScope, $mdDialog, errorValidatorUtil,
        navigatePeopleLookUp, localStorageService, 
        authService, CONSTANTS) {
        'ngInject';
        this.$state = $state
        var myUserId = localStorageService.get('user_id')
        //[Object] - Holds pagination data
        $scope.filteredItems = [];

        //Object - Holds selected filter query
        $scope.selectedObj = {}

        //[Object] - Holds filters object against each key(column name)
        $scope.values = []

        //Array - Holds column value of report(table)
        $scope.keys = []

        //[Array] - Holds object of fecthed result
        $scope.originalResultData = []

        //[Array] - Holds object of filtered result
        $scope.resultData = [];

        //Number -  To set current page number, by default 0
        $scope.currentPage = 0;

        //Number -  To set number of items to display inech page
        $scope.itemsPerPage = 50;

        //Number -  To set number of pagination page should display
        $scope.gap = $scope.itemsPerPage;

        //Number -  To set the pagination index
        $scope.paginationInt = 1;

        //Number - Length of the total collection
        $scope.totalCollectionLength = 0

        //Boolean - For showing loader
        $scope.loading = true;

        //String - Filter button label
        $scope.buttonLabel = 'Advanced Filter'

        //Boolean - For setting search privilege
        $scope.searchPrivilege = false

        //Object - Holds details of pages
        $scope.pager = {}

        //Show header title
        $rootScope.title = "People Search"
        let school_id = localStorageService.get('school_id')
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            $rootScope.title = "People Search"
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            //subsAcademicPack = self.subscribe('getAllAcademicPackageForParticularSchool', () => [Session.get('school_id')])
        }
        try {
            let object = {
                "actor": {
                    "mbox": "mailto:" + Meteor.user().username,
                    "account": {
                        "name": Meteor.user().name,
                        "homePage": SITE_URL
                    },
                    "objectType": "Agent"
                },
                "verb": {
                    "id": SITE_URL + "expapi/verbs/view",
                    "display": {
                        "en-US": "previewed"
                    }
                },
                "object": {
                    "id": window.location.href,
                    "definition": {
                        type: SITE_URL + "type/peoplelookup",
                        "name": {
                            "en-US": "People Lookup"
                        },
                        "description": {
                            "en-US": "People Lookup"
                        }
                    },
                    "objectType": "Agent"
                }
            }
            TinCanApiService.sendTincanApiRequest(object)
        } catch (ex) {

        }
        $scope.getUserList = function() {
            try{
                let obj = {
                    paginationInt : $scope.paginationInt,
                    school_id : school_id,
                    uploadUrl : CONSTANTS.FILE_UPLOAD_URL,
                    myUserId : myUserId
                }
                console.log('camehere')
                authService.callAPI("/v0/peoplelookup/fetch", "POST", 
                    {args : obj}, function (response) {
                        try{
                            if(response && response.result && response.result.data && response.result.data && response.result.data.details){
                                let result = response.result.data.details.response.response
                                if (!result || !result.user_details || result.user_details.length == 0) {
                                    toastr.error("No privileged uers to show")
                                    window.history.back();
                                    return
                                }
        
                                $scope.templateFilter = []
                                $scope.originalResultData = result.user_details
                                $scope.values = []
                                $scope.keys = _.keys($scope.originalResultData[0])
                                $scope.totalCollectionLength = result.total_users
                                $scope.keys = _.without($scope.keys, 'name', 'class_id', 'batch', 'batch_id', 'subject', 'subject_id', 'role_id', 'curriculum_id', 'session_id', 'user_id', 'username', 'image', 'empNo', 'admissionNo')
                                _.each($scope.keys, function(data) {
                                    let result = _.sortBy(fetchValues(data), "name")
                                    result.sort(function(a, b) {
                                        if (!isNaN(Number(a.name))) {
                                            return a.name - b.name
                                        } else {
                                            var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                                            var nameB = b.name.toUpperCase(); // ignore upper and lowercase
                                            if (nameA < nameB) {
                                                return -1;
                                            }
                                            if (nameA > nameB) {
                                                return 1;
                                            }
                                            return 0;
                                        }
                                    });
                                    $scope.values.push({
                                        key: data,
                                        label: $scope.keyReplaceCase(data),
                                        value: result,
                                        selected_text: ""
                                    });
                                })
                                $scope.selectedObj = {}
                                _.each($scope.values, function(pt) {
                                    let obj = _.filter(pt.value, function(ft) {
                                        return ft.is_selected == true
                                    })
                                    let names = _.without(obj, _.findWhere(obj, {
                                        name: 'undefined'
                                    }));
                                    names = _.pluck(names, "name")
                                    $scope.selectedObj[pt.key] = names
                                    pt.selected_text = "All"
                                })
                                _.each($scope.keys, function(key) {
                                    $scope.templateFilter.push({
                                        'key': key,
                                        'label': key,
                                        'is_required': true
                                    })
                                })
                                $scope.columnFilterResult(false)
                                $scope.paginationInt++
                                $scope.pager = {
                                    "page_no": 1,
                                    "start_page": 1,
                                    "end_page": Math.ceil($scope.originalResultData.length / $scope.itemsPerPage),
                                    "f_start_page": 1,
                                    "f_end_page": Math.ceil($scope.resultData.length / $scope.itemsPerPage),
                                    "filter_data": $scope.resultData.length,
                                    "total_data": $scope.totalCollectionLength,
                                    "received_data": $scope.originalResultData.length,
                                }
                                if ($scope.pager["received_data"] >= $scope.pager["total_data"] &&
                                    $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                                    $scope.hasValue = false
                                } else {
                                    $scope.hasValue = true
                                }
                                if ($scope.pager.f_start_page == $scope.pager.f_end_page) {
                                    fetchData($scope.paginationInt);
                                }
                                $scope.refreshReport()
                                $scope.loading = false;
                                
                            }else{
                                $scope.loading = false;
                                toastr.error("Unable to find user details.. Please try after some time")
                            }
                            _.defer(function() { $scope.$apply(); });
                        }catch(e){
                            console.log(e)
                        }
                })
                // Meteor.call("previewFacultyDetails", $scope.paginationInt, function(error, result) {
                //     if (error) {
                        
                //     } else {
                        
                //     }
                // })
            }catch(e){
                console.log(e)
            }
        }
        /*Roles and Privilege*/
        
        let features = localStorageService.get('feature_privileges')
        let userAccessJson = _.filter(features, function(feature) {
            return feature.module_state == "peopleSearch";
        });
        if (userAccessJson) {
            _.each(userAccessJson, function(feature) {
                if (feature.feature_id == 'peopleSearch') {
                    let user_access = {};
                    _.each(feature.privilege, function(privObj) {
                        user_access[privObj.name.toLowerCase()] = privObj.status
                    })
                    if (user_access.create == true || user_access.edit == true) {
                        $scope.searchPrivilege = true
                        $scope.getUserList()
                    }
                }
            })
        }
        $scope.loading = false;
        // UserPrivilages.getUserPrivilageInitialSetting(function(result) {
        //     if (result != undefined) {
        //         let features = result.feature_privileges;
        //         let userAccessJson = _.filter(features, function(feature) {
        //             return feature.module_state == "peopleSearch";
        //         });
        //         if (userAccessJson) {
        //             _.each(userAccessJson, function(feature) {
        //                 if (feature.feature_id == 'peopleSearch') {
        //                     let user_access = {};
        //                     _.each(feature.privilege, function(privObj) {
        //                         user_access[privObj.name.toLowerCase()] = privObj.status
        //                     })
        //                     if (user_access.create == true || user_access.edit == true) {
        //                         $scope.searchPrivilege = true
        //                         $scope.getUserList()
        //                     }
        //                 }
        //             })
        //         }
        //         $scope.loading = false;
        //     }
        // })

        /*
         * To fetch list of values against each column name
         * 
         * @key : Object - Selected column object contains key and customized label
         * 
         * @return : [Object] - List of values
         */
        function fetchValues(key) {
            let name, ids, arr = [];
            ids = _.compact(_.uniq(_.pluck($scope.originalResultData, key)))
            _.each(ids, function(dat) {
                if (dat != 'undefined') {
                    arr.push({
                        'name': dat,
                        'is_selected': true
                    })
                }
            })
            return arr
        }

        

        function fetchData(req_count) {
            try{
                $scope.loading = true;
                console.log('>>>>>>>>>>>>>>>>>>>>>')
                let obj = {
                    paginationInt : req_count,
                    school_id : school_id,
                    uploadUrl : CONSTANTS.FILE_UPLOAD_URL,
                    myUserId : myUserId
                }
                console.log('camehere')
                authService.callAPI("/v0/peoplelookup/fetch", "POST", 
                    {args : obj}, function (response) {
                        if(response.result && response.result.data && response.result.data && response.result.data.details){
                            let result = response.result.data.details.response.response
                            if (result) {
                                _.each(result.user_details, function(data) {
                                    $scope.originalResultData.push(data)
                                })
                                let filters = $scope.templateFilter;
                                _.each(filters, function(data) {
                                    let resultArr = []
                                    let ids = _.compact(_.uniq(_.pluck(result.user_details, data.key)))
                                    _.each(ids, function(dat) {
                                        resultArr.push({
                                            'name': dat,
                                            'is_selected': true
                                        })
                                    })
                                    if (resultArr.length > 0) {
                                        _.each($scope.values, function(dt, key) {
                                            if (dt.key === data.key) {

                                                let newArr = dt.value.concat(resultArr)
                                                let uniqArr = []

                                                var unique = {};
                                                _.each(newArr, function(item) {
                                                    if (!unique[item.name] && item.name != 'undefined') {
                                                        uniqArr.push(item);
                                                        unique[item.name] = item;
                                                    }
                                                });
                                                dt.value = uniqArr
                                            }
                                        })
                                    }
                                })
                                _.each($scope.values, function(pt) {
                                    let obj = _.filter(pt.value, function(ft) {
                                        return ft.is_selected == true
                                    })
                                    let names = _.pluck(obj, "name")
                                    $scope.selectedObj[pt.key] = names;
                                })
                                let page = $scope.pager.page_no
                                $scope.columnFilterResult(false)
                                $scope.loading = false;
                                $scope.paginationInt++;
                                $scope.pager.page_no = page
                                $scope.pager.end_page = Math.ceil($scope.originalResultData.length / $scope.itemsPerPage)
                                $scope.pager.f_end_page = Math.ceil($scope.resultData.length / $scope.itemsPerPage)
                                $scope.pager.filter_data = $scope.resultData.length
                                $scope.pager.received_data = $scope.originalResultData.length
                                if (($scope.pager.page_no - 1) * $scope.itemsPerPage >= $scope.pager.filter_data) {
                                    $scope.pager.page_no = $scope.pager.page_no - 1
                                }
                                if ($scope.pager["received_data"] >= $scope.pager["total_data"] &&
                                    $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                                    $scope.hasValue = false
                                } else {
                                    $scope.hasValue = true
                                }
                                $scope.groupToPages();
                                
                            } else {
                                $scope.loading = false
                            }
                        }
                        _.defer(function() { $scope.$apply(); });
                })
                // Meteor.call("previewFacultyDetails", req_count, function(error, result) {
                //     if (result) {
                //         _.each(result.user_details, function(data) {
                //             $scope.originalResultData.push(data)
                //         })
                //         let filters = $scope.templateFilter;
                //         _.each(filters, function(data) {
                //             let resultArr = []
                //             let ids = _.compact(_.uniq(_.pluck(result.user_details, data.key)))
                //             _.each(ids, function(dat) {
                //                 resultArr.push({
                //                     'name': dat,
                //                     'is_selected': true
                //                 })
                //             })
                //             if (resultArr.length > 0) {
                //                 _.each($scope.values, function(dt, key) {
                //                     if (dt.key === data.key) {

                //                         let newArr = dt.value.concat(resultArr)
                //                         let uniqArr = []

                //                         var unique = {};
                //                         _.each(newArr, function(item) {
                //                             if (!unique[item.name] && item.name != 'undefined') {
                //                                 uniqArr.push(item);
                //                                 unique[item.name] = item;
                //                             }
                //                         });
                //                         dt.value = uniqArr
                //                     }
                //                 })
                //             }
                //         })
                //         _.each($scope.values, function(pt) {
                //             let obj = _.filter(pt.value, function(ft) {
                //                 return ft.is_selected == true
                //             })
                //             let names = _.pluck(obj, "name")
                //             $scope.selectedObj[pt.key] = names;
                //         })
                //         let page = $scope.pager.page_no
                //         $scope.columnFilterResult(false)
                //         $scope.loading = false;
                //         $scope.paginationInt++;
                //         $scope.pager.page_no = page
                //         $scope.pager.end_page = Math.ceil($scope.originalResultData.length / $scope.itemsPerPage)
                //         $scope.pager.f_end_page = Math.ceil($scope.resultData.length / $scope.itemsPerPage)
                //         $scope.pager.filter_data = $scope.resultData.length
                //         $scope.pager.received_data = $scope.originalResultData.length
                //         if (($scope.pager.page_no - 1) * $scope.itemsPerPage >= $scope.pager.filter_data) {
                //             $scope.pager.page_no = $scope.pager.page_no - 1
                //         }
                //         if ($scope.pager["received_data"] >= $scope.pager["total_data"] &&
                //             $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                //             $scope.hasValue = false
                //         } else {
                //             $scope.hasValue = true
                //         }
                //         $scope.groupToPages();
                //         _.defer(function() { $scope.$apply(); });
                //     } else {
                //         $scope.loading = false
                //     }
                // })
            }catch(e){
                console.log(e)
            }
        }

        /*
         * Paginate to Previous page
         * 
         * @return : null
         */
        $scope.prevPage = function() {
            if ($scope.pager["page_no"] > 0) {
                $scope.pager["page_no"] = $scope.pager["page_no"] - 1
                if ($scope.pager["received_data"] >= $scope.pager["total_data"] &&
                    $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                    $scope.hasValue = false
                } else {
                    $scope.hasValue = true
                }
                $scope.setPaginationMsg();
            }
        }

        $scope.nextPage = function() {
            if ($scope.pager["page_no"] > 0) {
                $scope.pager["page_no"] = $scope.pager["page_no"] + 1
                if ($scope.pager["total_data"] > $scope.pager["received_data"] &&
                    ($scope.pager["page_no"] * $scope.itemsPerPage) >= $scope.pager["filter_data"]) {
                    fetchData($scope.paginationInt);
                }
                if ($scope.pager["received_data"] >= $scope.pager["total_data"] &&
                    $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                    $scope.hasValue = false
                } else {
                    $scope.hasValue = true
                }
                $scope.setPaginationMsg();
            }
        }

        $scope.goToPage = function(page) {
            if (page > 0) {
                $scope.pager["page_no"] = page
                if ($scope.pager["received_data"] >= $scope.pager["total_data"] &&
                    $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                    $scope.hasValue = false
                } else {
                    $scope.hasValue = true
                }
                $scope.setPaginationMsg();
            }
        }


        /*
         * To refresh report table
         * 
         * @return : null
         */
        $scope.refreshReport = function() {
            $scope.filteredItems = $scope.resultData;
            $scope.pager.page_no = 1;
            $scope.groupToPages();
        };

        /*
         * To generate group of page for pagination
         * 
         * @return : null
         */
        $scope.groupToPages = function() {
            $scope.pagedItems = [];
            try {
                for (var i = 0; i < $scope.filteredItems.length; i++) {
                    if (i % $scope.itemsPerPage === 0) {
                        $scope.pagedItems[Math.floor(i / $scope.itemsPerPage)] = [$scope.filteredItems[i]];
                    } else {
                        $scope.pagedItems[Math.floor(i / $scope.itemsPerPage)].push($scope.filteredItems[i]);
                    }
                }
                if ($scope.pagedItems.length < 11) {
                    $scope.gap = $scope.pagedItems.length
                } else {
                    $scope.gap = $scope.itemsPerPage
                }
                $scope.limit = $scope.pagedItems.length
                $scope.setPaginationMsg()
            } catch (e) {
                console.log(e)
            }
        }

        /*
         * To set pagination information message
         * 
         * @return : null
         */
        $scope.setPaginationMsg = function() {
            let start = 1;
            let end = $scope.itemsPerPage;
            let page = $scope.pager.page_no != undefined ? $scope.pager.page_no : 1;
            try {
                if (page != 1) {
                    start = (page * $scope.itemsPerPage) - ($scope.itemsPerPage - 1);
                    end = (start + $scope.pagedItems[$scope.pager.page_no - 1].length) - 1
                } else {
                    start = 1;
                    if ($scope.pager.page_no != undefined) {
                        end = (start + $scope.pagedItems[$scope.pager.page_no - 1].length) - 1
                    } else {
                        end = (start + $scope.pagedItems[0].length) - 1
                    }
                }
                // $scope.paginationMsg = start + " - " + end + " / " + $scope.filteredItems.length + " users"
                $scope.paginationMsg = start + " - " + end + " / " + $scope.totalCollectionLength + " users"
            } catch (ex) {
                $scope.paginationMsg = "There is no data against selected criteria"; //undefined
            }
        }

        /*
         * To replace '_' and convert each word first letler as Upper case letter
         * 
         * @data : String - Data to be replace
         * 
         * @return : String - Given data without Underscore
         */
        $scope.keyReplaceCase = function(data) {
            let str = data.replace(/_/g, ' ');
            return str.replace(/\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            })
        }

        $scope.navigatePeopleLookUp = function(user_obj) {
            try {
                let object = {
                    "actor": {
                        "mbox": "mailto:" + Meteor.user().username,
                        "account": {
                            "name": Meteor.user().name,
                            "homePage": SITE_URL
                        },
                        "objectType": "Agent"
                    },
                    "verb": {
                        "id": SITE_URL + "expapi/verbs/interacted",
                        "display": {
                            "en-US": "clicked"
                        }
                    },
                    "object": {
                        "id": window.location.href,
                        "definition": {
                            type: SITE_URL + "type/peoplelookup",
                            "name": {
                                "en-US": "Userdetails"
                            },
                            "description": {
                                "en-US": "view user details"
                            }
                        },
                        "objectType": "Agent"
                    }
                }
                TinCanApiService.sendTincanApiRequest(object)
            } catch (ex) {

            }

            if (user_obj && user_obj !== 0) {
                let pdfUserAccsssess = navigatePeopleLookUp.setUserInput(user_obj);
                localStorageService.set('selectUser', user_obj.user_id);
                localStorageService.set('FROMSEARCH', "true");
                $state.go('myProfile')
            } else {
                toastr.error("Insufficient data available. Please select another user")
            }
        }

        /*
         * To close the all opened dropdwon
         * 
         * @event : Object - Current element object
         * 
         * @return : null
         */
        $scope.keyDownHandler = function(event) {
            if (event.target != null && event.target.offsetParent != null) {
                if (event.target.id === "btnSelect" || event.target.offsetParent.id === "lstItem") {
                    return
                } else {
                    _.each($scope.values, function(dt) {
                        dt.open = false
                    })
                }
            }
        }

        /*
         * To open/close filter dropdown
         * 
         * @data : Object - Object of selected column filter
         * 
         * @return : null
         */
        $scope.toggleDropdown = function(data) {
            if (data != undefined) {
                _.each($scope.values, function(dt) {
                    if (data.key == dt.key) {
                        dt.open = !dt.open
                    } else {
                        dt.open = false
                    }
                })
            }
        }

        /*
         * To generate list of selected values depends on the selection/dis selection of value
         * 
         * @data : Object - Selected value object against column name
         * @key : String - Selected column name
         * 
         * @return : null
         */
        $scope.setFilterObj = function(data, key) {
            if (data && key) {
                if (!data.is_selected) {
                    let obj = _.reject($scope.selectedObj[key], function(kt) {
                        return kt === data.name
                    })
                    if (obj) {
                        $scope.selectedObj[key] = obj
                    }
                } else {
                    if (data && data.name) {
                        if (!_.contains($scope.selectedObj[key], data.name)) {
                            if ($scope.selectedObj[key] != undefined) {
                                $scope.selectedObj[key].push(data.name)
                            } else {
                                $scope.selectedObj[key] = []
                                $scope.selectedObj[key].push(data.name)
                            }
                        }
                    }
                }
            }
        }

        /*
         * To filter result based on the selection/disselection of value in each column filter
         * 
         * @isManual : Boolean - To define whether this function called by manual button click
         * 
         * @return : null
         */
        $scope.columnFilterResult = function(isManual) {
            if (isManual) {
                _.each($scope.values, function(val) {
                    _.each(val.value, function(key, index) {
                        if (key.name != 'undefined') {
                            if (!_.contains($scope.selectedObj[val.key], key.name)) {
                                key.is_selected = false
                            } else {
                                key.is_selected = true
                            }
                        }
                    })
                })
            }
            _.each($scope.values, function(val) {
                let nonSelecteditems = _.filter(val.value, function(data) {
                    return data.is_selected === false
                })
                if (nonSelecteditems.length === 0) {
                    val.selected_text = "All"
                } else {
                    val.selected_text = "Custom"
                }
            })
            let allKeys = _.keys($scope.selectedObj)
            let customKeys = _.filter($scope.values, function(val) {
                return val.selected_text === "Custom"
            })
            let customKey = _.pluck(customKeys, "key")
            allKeys = customKey;
            let selectedValueCount = 0
            _.each(allKeys, function(key) {
                if ($scope.selectedObj[key] !== undefined && $scope.selectedObj[key].length > 0) {
                    selectedValueCount++
                }
            })
            if (selectedValueCount == allKeys.length) {
                _.each(allKeys, function(ch, pKey) {
                    if ($scope.selectedObj[ch] !== undefined && $scope.selectedObj[ch].length > 0) {
                        if ($scope.selectedObj[ch].length == 1) {
                            let searchObj = {}
                            searchObj[ch] = $scope.selectedObj[ch][0]
                            if ($scope.chatData == undefined || $scope.chatData.length === 0) {
                                $scope.chatData = _.where($scope.originalResultData, searchObj)
                            } else {
                                if (pKey == 0) {
                                    $scope.chatData = _.where($scope.originalResultData, searchObj)
                                } else {
                                    $scope.chatData = _.where($scope.chatData, searchObj)
                                }
                            }
                        } else {
                            let chatData = []
                            let selectedObjLen = $scope.selectedObj[ch];
                            for (var i = 0; i < selectedObjLen.length; i++) {
                                let searchObj = {}
                                searchObj[ch] = $scope.selectedObj[ch][i]
                                if (chatData.length === 0) {
                                    if (pKey == 0) {
                                        $scope.chatData = _.where($scope.originalResultData, searchObj)
                                        chatData = _.where($scope.originalResultData, searchObj)
                                    } else {
                                        chatData = _.where($scope.chatData, searchObj);
                                    }
                                    if (i == $scope.selectedObj[ch].length - 1) {
                                        $scope.chatData = chatData
                                    }
                                } else {
                                    let resultArray;
                                    if (pKey == 0) {
                                        resultArray = _.where($scope.originalResultData, searchObj)
                                    } else {
                                        resultArray = _.where($scope.chatData, searchObj)
                                    }
                                    if (i == 0) {
                                        chatData = resultArray
                                    } else {
                                        _.each(resultArray, function(data) {
                                            chatData.push(data)
                                        })
                                    }
                                    if (i == $scope.selectedObj[ch].length - 1) {
                                        $scope.chatData = chatData
                                    }
                                }
                            }
                        }
                    } else {
                        $scope.chatData = []
                    }
                })
            } else {
                $scope.chatData = []
            }
            if (allKeys.length > 0) {
                $scope.resultData = $scope.chatData
            } else {
                $scope.resultData = $scope.originalResultData
            }
            $scope.totalItems = $scope.resultData.length;
            $scope.filteredItems = $scope.resultData;
            $scope.refreshReport();
            $scope.groupToPages();
            $scope.setPaginationMsg();
            $scope.pager.end_page = Math.ceil($scope.originalResultData.length / $scope.itemsPerPage)
            $scope.pager.f_end_page = Math.ceil($scope.resultData.length / $scope.itemsPerPage)
            $scope.pager.filter_data = $scope.resultData.length
            $scope.pager.received_data = $scope.originalResultData.length
            if ($scope.pager["received_data"] >= $scope.pager["total_data"] &&
                $scope.pager["page_no"] == $scope.pager["f_end_page"]) {
                $scope.hasValue = false
            } else {
                $scope.hasValue = true
            }
        }

        /*
         * To select all values in column filter
         * 
         * @data : Object - Object of selected column filter
         * @key : String - Selected column filter name
         * 
         * @return : null
         */
        $scope.setAllData = function(data, key) {
            _.each(data, function(dt) {
                dt.is_selected = true
            })
            _.each($scope.values, function(val) {
                let nonSelecteditems = _.filter(val.value, function(data) {
                    return data.is_selected === false
                })
                if (nonSelecteditems.length === 0) {
                    val.selected_text = "All"
                } else {
                    val.selected_text = "Custom"
                }
            })
            let keyBasedValues = _.pluck(data, 'name');
            $scope.selectedObj[key] = keyBasedValues
            $scope.columnFilterResult(true);
        }

        /*
         * To unselect all values in column filter
         * 
         * @data : Object - Object of selected column filter
         * @key : String - Selected column filter name
         * 
         * @return : null
         */
        $scope.unSetAllData = function(data, key) {
            _.each(data, function(dt) {
                dt.is_selected = false
            })
            _.each($scope.values, function(val) {
                let nonSelecteditems = _.filter(val.value, function(data) {
                    return data.is_selected === false
                })
                if (nonSelecteditems.length === 0) {
                    val.selected_text = "All"
                } else {
                    val.selected_text = "Custom"
                }
            })
            $scope.selectedObj[key] = []
            $scope.columnFilterResult(true);
        }

        /*
         * To replace '_' and convert each word first letler as Upper case letter
         * 
         * @data : String - Data to be replace
         * 
         * @return : String - Given data without Underscore
         */
        $scope.keyReplaceCase = function(data) {
            let str = data.replace(/_/g, ' ');
            return str.replace(/\w\S*/g, function(txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            })
        }

        $scope.enableFilter = function() {
            $scope.buttonLabel == 'Advanced Filter' ? $scope.buttonLabel = 'Hide Filter' : $scope.buttonLabel = 'Advanced Filter'
            try {
                let object = {
                    "actor": {
                        "mbox": "mailto:" + Meteor.user().username,
                        "account": {
                            "name": Meteor.user().name,
                            "homePage": SITE_URL
                        },
                        "objectType": "Agent"
                    },
                    "verb": {
                        "id": SITE_URL + "expapi/verbs/interacted",
                        "display": {
                            "en-US": clicked
                        }
                    },
                    "object": {
                        "id": window.location.href,
                        "definition": {
                            type: SITE_URL + "type/peoplelookup",
                            "name": {
                                "en-US": $scope.buttonLabel
                            },
                            "description": {
                                "en-US": $scope.buttonLabel
                            }
                        },
                        "objectType": "Agent"
                    }
                }
                TinCanApiService.sendTincanApiRequest(object)
            } catch (ex) {

            }
        }
    }
}
export default PeopleSearch;


// WEBPACK FOOTER //
// ./src/app/people_lookup/controllers/peoplelookupController.js